<template>
  <v-card class="d-flex flex-column align-center justify-center pa-5">
    <v-card-title class="mb-5">Διαγραφή Εργαζομένου</v-card-title>
    <v-form class="form d-flex flex-column justify-center">
      <div>Είστε σίγουροι ότι θέλετε να διαγράψετε μόνιμα το χρήστη?</div>
      <div class="d-flex justify-center mt-16">
        <v-btn
          class="success rounded text-sm-body-1 font-weight-regular mr-5"
          :loading="loader"
          @click="onDelete"
        >
          <span>Διαγραφή</span>
        </v-btn>
        <v-btn
          class="secondary rounded text-sm-body-1 font-weight-regular"
          @click="$emit('closeDialog')"
        >
          <span>Επιστροφή</span>
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  props: {
    currentUser: Object,
  },

  data() {
    return {
      loader: false,
    };
  },

  methods: {
    async onDelete() {
      try {
        this.loader = false;

        await axios.post(
          `${process.env.VUE_APP_BASE_URL}/admin/removehcmcemployee`,
          {
            HcmcEmployeeId: this.currentUser.hcmcEmployeeId,
          }
        );

        await this.$emit("getUsers");
        this.loader = true;
        this.$store.commit("toggleSnackbar", {
          open: true,
          color: "success",
          text: "Η διαγραφή εργαζομένου ολοκληρώθηκε με επιτυχία!",
        });
        this.$emit("closeDialog");
      } catch (e) {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
</style>